import { colors } from './colors';
import { fonts } from './fonts';
import { buttons } from './buttons';
import { popover } from './popover';
import { tag } from './tag';
import { paymentMethodRadio } from './paymentMethodRadio';

export const theme = {
  colors,
  fonts,
  buttons,
  popover,
  paymentMethodRadio,
  tag,
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
  },
};
